module.exports = __webpack_public_path__ + "img/c03_unitbowmanchampion_Normal_ua.1bc7d463.webp";